<template>
  <div>
    <div v-if="mobile" style="padding: 0 10px" @click="toggleClick">
      <svg
        :class="{ 'sidebar.open': isActive }"
        class="hamburger"
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
      >
        <path
          d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
        />
      </svg>
    </div>

    <div class="menu" v-if="!mobile">
      <el-col>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item
            v-for="(item, index) in routeNameList"
            :key="index"
          >
            <span v-if="index != 0">{{ $t(item.meta.title) }}</span>
            <a v-else @click.prevent="handleLink(item)">{{
              $t(item.meta.title)
            }}</a>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </div>

    <rightPane></rightPane>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import Hamburger from "@/components/Hamburger";
import rightPane from "./ScrollPane.vue";
import * as pathToRegexp from "path-to-regexp";
import { getLang } from "@/utils/auth/";
import { useRoute } from "vue-router";
export default {
  mounted() {
    // console.log(this.$store.state.app.sidea);
  },
  components: {
    // Hamburger,
    rightPane,
  },
  computed: {
    ...mapGetters(["sidebar"]),
  },
  data() {
    return {
      routeNameList: null,
      isCollapse: true,
      isShow1: true,
      isShow2: false,
      mobile: false,
    };
  },
  created() {
    this.getBreadcrumb();
  },
  beforeMount() {
    this.IsPC();
  },
  methods: {
    IsPC() {
      let userAgent = navigator.userAgent.toLowerCase();
      // 用 test 匹配浏览器信息
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          userAgent
        )
      ) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    toggleClick() {
      this.$store.commit("ISFOLD");
    },
    getBreadcrumb() {
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
      matched = [{ path: "/home", meta: { title: "routers.home" } }].concat(
        matched
      );
      const first = matched[0];
      // if (!this.isDashBoard(first)) {
      //   if (getLang() == "zh-CN") {

      //   }
      //   if (getLang() == "zh-HK") {
      //     matched = [{ path: "/home", meta: { title: "首頁" } }].concat(
      //       matched
      //     );
      //   }
      //   if (getLang() == "en") {
      //     matched = [{ path: "/home", meta: { title: "Home" } }].concat(
      //       matched
      //     );
      //   }
      // }
      this.routeNameList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
      // console.log("this.routeNameList ", this.routeNameList, matched);
    },
    isDashBoard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return (
        name.trim().toLocaleLowerCase() === "Dashboard".toLocaleLowerCase()
      );
    },
    pathCompile(path) {
      const { params } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink(item) {
      const { redirect, path } = item;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.pathCompile(path));
    },
  },
  watch: {
    $route(route) {
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    },
  },
};
</script>

<style>
.user {
  float: right;
}
.avatar-container {
  margin-right: 30px;
}
.avatar-container .avatar-wrapper {
  margin-top: 5px;
  position: relative;
}
.right-menu-item {
  display: inline-block;
  padding: 0 8px;
  height: 100%;
  font-size: 18px;
  color: #5a5e66;
  vertical-align: text-bottom;
}
.right-menu-item .hover-effect {
  cursor: pointer;
  transition: background 0.3s;
}
.menu {
  padding: auto;
  float: left;
  height: 100%;
  font-size: 40px;
  margin: 20px 0 0 20px;
  background-color: #fff;
}
.btn {
  padding: auto;
  float: right;
  height: 100%;
  font-size: 40px;
  background-color: #fff;
}
.btn el-dropdown {
  top: 25%;
}
.hamburger.is-active {
  transform: rotate(180deg);
}
.hamburger {
  float: left;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  margin: 15px 5px 0 0;
  background-color: #fff;
}
.el-scrollbar__bar.is-horizontal {
  height: 0;
  width: 0;
}
</style>
